import { featureFlagNames } from '@/client/featureFlagClient';
import { EXPERIMENT_TRUEDMED_PAYMENTS } from '@/lib/constants/experiments';
import { useSiteStore } from '@/store/SiteStoreProvider';
import { useShallow } from 'zustand/react/shallow';

export const useShouldShowTruemedBanner = () => {
  const { shouldShowTruemedBanner } = useSiteStore(
    useShallow(({ featureFlags, experimentVariants }) => ({
      shouldShowTruemedBanner:
        featureFlags[featureFlagNames.TRUEDMED_PAYMENTS] &&
        experimentVariants[EXPERIMENT_TRUEDMED_PAYMENTS] === 'experiment',
    })),
  );
  return shouldShowTruemedBanner;
};
